/* eslint-disable no-unused-vars */
// needed since color isn't used in the template but appears in the replaced body
import React from "react";
import PropTypes from "prop-types";

/*
 * Yuka v2.0
 * This component corresponds to ``fingerprint.svg``
 *
 * @param {Object} props
 *
 * @returns {React.Element}
 */
const FingerprintIcon = ({ color, size }) => (
  <svg width={size} height={size} viewBox="0 0 18 18">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <path
        fill={color}
        fillRule="evenodd"
        d="M5.62446 2.40349C6.61806 1.82872 7.77178 1.5 9 1.5C12.7279 1.5 15.75 4.52208 15.75 8.25C15.75 10.175 15.4812 12.0385 14.9786 13.8043C14.8652 14.2027 14.4503 14.4337 14.0519 14.3203C13.6535 14.2069 13.4225 13.792 13.5359 13.3937C14.0009 11.7601 14.25 10.0348 14.25 8.25C14.25 5.3505 11.8995 3 9 3C8.0425 3 7.14699 3.25564 6.37555 3.7019C6.017 3.90931 5.55821 3.78678 5.3508 3.42824C5.14339 3.06969 5.26591 2.6109 5.62446 2.40349ZM4.17824 4.6008C4.53679 4.8082 4.65931 5.267 4.4519 5.62554C4.00565 6.39699 3.75 7.2925 3.75 8.25C3.75 9.53947 3.45364 10.7618 2.92461 11.8508C2.74361 12.2234 2.29485 12.3787 1.92228 12.1977C1.5497 12.0167 1.3944 11.5679 1.5754 11.1954C2.00736 10.3062 2.25 9.3075 2.25 8.25C2.25 7.02178 2.57873 5.86805 3.15349 4.87446C3.3609 4.51591 3.81969 4.39339 4.17824 4.6008ZM5.24993 8.25C5.24993 6.17893 6.92887 4.5 8.99993 4.5C11.071 4.5 12.7499 6.17893 12.7499 8.25C12.7499 9.04685 12.6957 9.83192 12.5906 10.6015C12.5345 11.0119 12.1564 11.2992 11.746 11.2431C11.3356 11.187 11.0483 10.8089 11.1044 10.3985C11.2003 9.69595 11.2499 8.9787 11.2499 8.25C11.2499 7.00736 10.2426 6 8.99993 6C7.75729 6 6.74993 7.00736 6.74993 8.25C6.74993 10.4517 6.11974 12.4993 5.03082 14.2304C5.0203 14.2471 5.01003 14.2639 5.00001 14.2807C4.7885 14.6369 4.32833 14.7541 3.97219 14.5426C3.61605 14.3311 3.4988 13.8709 3.71032 13.5148C3.72686 13.4869 3.7438 13.4592 3.76114 13.4317L4.39598 13.831L3.76114 13.4317C4.70396 11.9329 5.24993 10.161 5.24993 8.25ZM8.99991 7.5C9.41412 7.5 9.74991 7.83579 9.74991 8.25C9.74991 11.0333 8.95119 13.6323 7.57014 15.8278C7.34959 16.1784 6.88657 16.2838 6.53596 16.0632C6.18534 15.8427 6.07991 15.3797 6.30047 15.0291C7.53545 13.0658 8.24991 10.7425 8.24991 8.25C8.24991 7.83579 8.58569 7.5 8.99991 7.5ZM11.5823 12.0283C11.9808 12.1411 12.2125 12.5556 12.0997 12.9542C11.803 14.0028 11.4097 15.0111 10.93 15.9687C10.7444 16.339 10.2938 16.4888 9.92348 16.3033C9.55314 16.1177 9.40332 15.6671 9.58886 15.2968C10.0267 14.4228 10.3856 13.5025 10.6564 12.5458C10.7692 12.1472 11.1837 11.9156 11.5823 12.0283Z"
        transform=""
      />
    </g>
  </svg>
);

FingerprintIcon.propTypes = {
  // all of these can be overriden in CSS as necessary
  color: PropTypes.string,
  size: PropTypes.number,
};

FingerprintIcon.defaultProps = {
  color: "#ffffff",
  size: 16,
};

FingerprintIcon.displayName = "FingerprintIcon";

export default FingerprintIcon;
